import type { SessionSettings } from '@/types/session';
import { initI18n, applyDocumentLanguage } from '@/i18n';
import { normalizeLanguageCode } from '@/i18n/resources';

let currentLanguageCode = 'en_US';

export function getActiveLanguageCode(): string {
  return currentLanguageCode;
}

/** BCP-47 locale for Intl formatting driven by the active UI language. */
export function getUiIntlLocale(): string {
  return getActiveLanguageCode().replace('_', '-');
}

export async function applyLanguageSettings(settings?: SessionSettings | null): Promise<void> {
  const languageCode = normalizeLanguageCode(settings?.languageCode);
  currentLanguageCode = languageCode;
  await initI18n(languageCode);
  applyDocumentLanguage(languageCode);
}

export function resetLanguageSettings(): void {
  currentLanguageCode = 'en_US';
  void initI18n('en_US');
}
